import { Heading } from '@cinch-labs/design-system'
import cx from 'classnames'

import {
  CinchChargeLogo,
  CinchChargePurpleLogo,
  CinchShieldLogo,
} from '../assets'
import styles from './title-with-logo.module.css'

export interface TitleWithLogoProps {
  headingLevel: 'h1' | 'h2' | 'h3' | 'h4'
  leftText?: string
  rightText?: string
  textClassName?: string
  logo?: 'cinchShield' | 'cinchCharge' | 'cinchChargePurple'
  logoHeight?: string
  logoWidth?: string
  centered?: boolean
  wrapperClassName?: string
}

const TitleWithLogo: React.FC<TitleWithLogoProps> = ({
  headingLevel,
  leftText,
  rightText,
  textClassName,
  logo,
  logoHeight = '36',
  logoWidth = '182',
  centered = false,
  wrapperClassName,
}) => {
  const displayLogo = () => {
    switch (logo) {
      case 'cinchShield': {
        return (
          <CinchShieldLogo
            className={styles.logo}
            height={logoHeight}
            width={logoWidth}
            data-testid="cinch-shield-logo"
          />
        )
      }
      case 'cinchCharge': {
        return (
          <CinchChargeLogo
            className={styles.logo}
            height={logoHeight}
            width={logoWidth}
            data-testid="cinch-shield-logo"
          />
        )
      }
      case 'cinchChargePurple': {
        return (
          <CinchChargePurpleLogo
            className={styles.logo}
            height={logoHeight}
            width={logoWidth}
            data-testid="cinch-shield-logo"
          />
        )
      }
      default: {
        return
      }
    }
  }

  const renderTitleAndLogo = () => {
    if (!logo && (leftText || rightText)) {
      return (
        <Heading element={headingLevel} className={textClassName}>
          {leftText + ' ' + rightText}
        </Heading>
      )
    }
    if (leftText && rightText && logo) {
      return (
        <>
          <Heading element={headingLevel} className={textClassName}>
            {leftText}
          </Heading>
          <div
            style={{ height: logoHeight + 'px', width: logoWidth + 'px' }}
            className={cx(styles.logoLeft, styles.logoRight)}
          >
            {displayLogo()}
          </div>
          <Heading element={headingLevel} className={textClassName}>
            {rightText}
          </Heading>
        </>
      )
    }
    if (leftText && !rightText && logo) {
      return (
        <>
          <Heading element={headingLevel} className={textClassName}>
            {leftText}
          </Heading>
          <div
            style={{ height: logoHeight + 'px', width: logoWidth + 'px' }}
            className={styles.logoRight}
          >
            {displayLogo()}
          </div>
        </>
      )
    }
    if (!leftText && rightText && logo) {
      return (
        <>
          <div
            style={{ height: logoHeight + 'px', width: logoWidth + 'px' }}
            className={styles.logoLeft}
          >
            {displayLogo()}
          </div>
          <Heading element={headingLevel} className={styles.leftText}>
            {rightText}
          </Heading>
        </>
      )
    }
    return
  }

  return (
    <div
      className={cx(
        styles.wrapper,
        { [styles.centerAlign]: centered },
        wrapperClassName,
      )}
    >
      {renderTitleAndLogo()}
    </div>
  )
}

export default TitleWithLogo
